// extracted by mini-css-extract-plugin
module.exports = {"LRMessage":"LRMessage_LRMessage__DmjL2"};